import { Input, InputProps } from '@chakra-ui/react';

const defaultStyles: InputProps = {
    backgroundColor: 'white',
};

export function DrawerInput(props: InputProps) {
    return <Input {...defaultStyles} {...props} />;
}
